export function HomePage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center space-y-4 max-w-sm">
        <div className="text-6xl">📷</div>
        <h1 className="text-xl font-bold text-gray-900">깨봉 Play</h1>
        <p className="text-gray-600 leading-relaxed">
          교재의 QR 코드를 스마트기기로 스캔하여<br />
          접속해주세요.
        </p>
      </div>
    </div>
  )
}
